import { Button } from "antd"

const Support = () => {
    return (
        <div>
            <h2>Syarat dan Ketentuan</h2>
            <p>1. Download dan install aplikasi datt dari app store atau play store</p>
            <p>2. Diperuntukan hanya kepada karyawan PT SENDOK GARPU INTERNASIONAL</p>
            <p>3. Masuk dengan ID karyawan dan tanggal lahir</p>
            <h2>Bantuan Admin</h2>
            <Button ><a
                href="https://wa.me/6281947775484?text=Hai%20admin"
                target="_blank"
                rel="noopener noreferrer"
            >Tanya & Bantuan</a></Button>
        </div>
    )
}
export default Support